module.exports = __webpack_public_path__ + "img/02.f91a4b44.png";